import React, { useState, useEffect } from 'react';
import './AnalyseModal.css';

const AnalyseModal = ({ prozess, analyse, onSave, onCancel }) => {
    const [formData, setFormData] = useState({
        prozess_id: prozess?.prozess_id || '',
        vertraulichkeit: 'normal',
        integritaet: 'normal',
        verfuegbarkeit: 'normal',
        authentizitaet: 'normal',
        vertraulichkeit_begruendung: '',
        integritaet_begruendung: '',
        verfuegbarkeit_begruendung: '',
        authentizitaet_begruendung: '',
        status: 'entwurf',
    });

    const schutzstufen = [
        { value: 'gering', label: 'Gering', color: '#10b981', description: 'Geringer Schutzbedarf' },
        { value: 'normal', label: 'Normal', color: '#22c55e', description: 'Normaler Schutzbedarf' },
        { value: 'hoch', label: 'Hoch', color: '#f59e0b', description: 'Hoher Schutzbedarf' },
        { value: 'sehr_hoch', label: 'Sehr Hoch', color: '#ef4444', description: 'Sehr hoher Schutzbedarf' },
    ];

    useEffect(() => {
        if (analyse) {
            setFormData({
                prozess_id: analyse.prozess_id,
                vertraulichkeit: analyse.vertraulichkeit,
                integritaet: analyse.integritaet,
                verfuegbarkeit: analyse.verfuegbarkeit,
                authentizitaet: analyse.authentizitaet || 'normal',
                vertraulichkeit_begruendung: analyse.vertraulichkeit_begruendung || '',
                integritaet_begruendung: analyse.integritaet_begruendung || '',
                verfuegbarkeit_begruendung: analyse.verfuegbarkeit_begruendung || '',
                authentizitaet_begruendung: analyse.authentizitaet_begruendung || '',
                status: analyse.status,
            });
        }
    }, [analyse]);

    const handleSchutzzieleChange = (schutzziel, value) => {
        setFormData(prev => ({
            ...prev,
            [schutzziel]: value
        }));
    };

    const handleBegruendungChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const calculateGesamtschutzbedarf = () => {
        const levels = [formData.vertraulichkeit, formData.integritaet, formData.verfuegbarkeit, formData.authentizitaet];
        if (levels.includes('sehr_hoch')) return 'sehr_hoch';
        if (levels.includes('hoch')) return 'hoch';
        return 'normal';
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    const gesamtschutzbedarf = calculateGesamtschutzbedarf();

    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="modal analyse-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <div>
                        <h2>{analyse ? 'Analyse bearbeiten' : 'Neue Schutzbedarfsanalyse'}</h2>
                        <p className="modal-subtitle">{prozess?.prozess_name}</p>
                    </div>
                    <button className="modal-close" onClick={onCancel}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        {/* Vertraulichkeit */}
                        <div className="schutzziel-section">
                            <div className="schutzziel-header">
                                <h3>Vertraulichkeit</h3>
                                <p className="schutzziel-description">
                                    Schutz vor unbefugter Kenntnisnahme von Informationen
                                </p>
                            </div>

                            <div className="stufen-grid">
                                {schutzstufen.map((stufe) => (
                                    <button
                                        key={stufe.value}
                                        type="button"
                                        className={`stufe-btn stufe-btn-${stufe.value} ${formData.vertraulichkeit === stufe.value ? 'selected' : ''}`}
                                        onClick={() => handleSchutzzieleChange('vertraulichkeit', stufe.value)}
                                    >
                                        <strong>{stufe.label}</strong>
                                        <span>{stufe.description}</span>
                                    </button>
                                ))}
                            </div>

                            <div className="form-group">
                                <label className="form-label">Begründung</label>
                                <textarea
                                    className="form-input form-textarea"
                                    value={formData.vertraulichkeit_begruendung}
                                    onChange={(e) => handleBegruendungChange('vertraulichkeit_begruendung', e.target.value)}
                                    placeholder="Begründung für die Einstufung..."
                                    rows={3}
                                />
                            </div>
                        </div>

                        {/* Integrität */}
                        <div className="schutzziel-section">
                            <div className="schutzziel-header">
                                <h3>Integrität</h3>
                                <p className="schutzziel-description">
                                    Schutz vor unbefugter Veränderung von Informationen
                                </p>
                            </div>

                            <div className="stufen-grid">
                                {schutzstufen.map((stufe) => (
                                    <button
                                        key={stufe.value}
                                        type="button"
                                        className={`stufe-btn stufe-btn-${stufe.value} ${formData.integritaet === stufe.value ? 'selected' : ''}`}
                                        onClick={() => handleSchutzzieleChange('integritaet', stufe.value)}
                                    >
                                        <strong>{stufe.label}</strong>
                                        <span>{stufe.description}</span>
                                    </button>
                                ))}
                            </div>

                            <div className="form-group">
                                <label className="form-label">Begründung</label>
                                <textarea
                                    className="form-input form-textarea"
                                    value={formData.integritaet_begruendung}
                                    onChange={(e) => handleBegruendungChange('integritaet_begruendung', e.target.value)}
                                    placeholder="Begründung für die Einstufung..."
                                    rows={3}
                                />
                            </div>
                        </div>

                        {/* Verfügbarkeit */}
                        <div className="schutzziel-section">
                            <div className="schutzziel-header">
                                <h3>Verfügbarkeit</h3>
                                <p className="schutzziel-description">
                                    Sicherstellung des Zugriffs auf Informationen
                                </p>
                            </div>

                            <div className="stufen-grid">
                                {schutzstufen.map((stufe) => (
                                    <button
                                        key={stufe.value}
                                        type="button"
                                        className={`stufe-btn stufe-btn-${stufe.value} ${formData.verfuegbarkeit === stufe.value ? 'selected' : ''}`}
                                        onClick={() => handleSchutzzieleChange('verfuegbarkeit', stufe.value)}
                                    >
                                        <strong>{stufe.label}</strong>
                                        <span>{stufe.description}</span>
                                    </button>
                                ))}
                            </div>

                            <div className="form-group">
                                <label className="form-label">Begründung</label>
                                <textarea
                                    className="form-input form-textarea"
                                    value={formData.verfuegbarkeit_begruendung}
                                    onChange={(e) => handleBegruendungChange('verfuegbarkeit_begruendung', e.target.value)}
                                    placeholder="Begründung für die Einstufung..."
                                    rows={3}
                                />
                            </div>
                        </div>

                        {/* Authentizität */}
                        <div className="schutzziel-section">
                            <div className="schutzziel-header">
                                <h3>Authentizität</h3>
                                <p className="schutzziel-description">
                                    Sicherstellung der Echtheit und Glaubwürdigkeit von Informationen
                                </p>
                            </div>

                            <div className="stufen-grid">
                                {schutzstufen.map((stufe) => (
                                    <button
                                        key={stufe.value}
                                        type="button"
                                        className={`stufe-btn stufe-btn-${stufe.value} ${formData.authentizitaet === stufe.value ? 'selected' : ''}`}
                                        onClick={() => handleSchutzzieleChange('authentizitaet', stufe.value)}
                                    >
                                        <strong>{stufe.label}</strong>
                                        <span>{stufe.description}</span>
                                    </button>
                                ))}
                            </div>

                            <div className="form-group">
                                <label className="form-label">Begründung</label>
                                <textarea
                                    className="form-input form-textarea"
                                    value={formData.authentizitaet_begruendung}
                                    onChange={(e) => handleBegruendungChange('authentizitaet_begruendung', e.target.value)}
                                    placeholder="Begründung für die Einstufung..."
                                    rows={3}
                                />
                            </div>
                        </div>

                        {/* Gesamtschutzbedarf */}
                        <div className="gesamtschutzbedarf-box">
                            <h4>Gesamtschutzbedarf</h4>
                            <div className="gesamtschutzbedarf-value">
                                <span
                                    className="schutzbedarf-badge-large"
                                    style={{
                                        background: gesamtschutzbedarf === 'sehr_hoch' ? '#ef4444' :
                                            gesamtschutzbedarf === 'hoch' ? '#f59e0b' : '#22c55e'
                                    }}
                                >
                                    {gesamtschutzbedarf === 'sehr_hoch' ? 'Sehr Hoch' :
                                        gesamtschutzbedarf === 'hoch' ? 'Hoch' : 'Normal'}
                                </span>
                                <span className="help-text">
                                    (Höchster Wert der vier Schutzziele)
                                </span>
                            </div>
                        </div>

                        {/* Status */}
                        <div className="form-group">
                            <label className="form-label">Status</label>
                            <select
                                className="form-select"
                                value={formData.status}
                                onChange={(e) => setFormData(prev => ({ ...prev, status: e.target.value }))}
                            >
                                <option value="entwurf">Entwurf</option>
                                <option value="in_bearbeitung">In Bearbeitung</option>
                                <option value="abgeschlossen">Abgeschlossen</option>
                            </select>
                        </div>
                    </div>

                    <div className="modal-actions">
                        <button type="button" onClick={onCancel} className="btn-secondary btn-medium">
                            Abbrechen
                        </button>
                        <button type="submit" className="btn-primary btn-medium">
                            {analyse ? 'Speichern' : 'Erstellen'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AnalyseModal;